import { utils } from '@ricky0123/vad-react';

export const encodeAudio = (sample) => {
  const buffer = utils.encodeWAV(sample);

  return new Blob([buffer], { type: 'audio/wav' });
};
